<template>
  <v-layout column class="pa-4 my-12" justify-center align-center>
    <v-col cols="12">
      <v-card class="mb-6 pa-3" height="50px" color="#FBDE3C" dark>
        <v-layout>
          <span
            class="ml-3 black--text font-weight-black"
            style="font-size: 1.3em"
            >Lista Zamówień</span
          >
        </v-layout>
      </v-card>
      <v-expansion-panels>
        <v-expansion-panel
          class="mb-6"
          style="background-color: #fbde3c"
          v-for="(item, i) in 1"
          :key="i"
        >
          <v-expansion-panel-header>
            <span class="black--text font-weight-black" style="font-size: 1.3em"
              >Filtracja Wyników</span
            >
          </v-expansion-panel-header>
          <v-expansion-panel-content style="background-color: white">
            <v-layout wrap class="pa-5">
              <v-col cols="6">
                <v-text-field
                  hide-details
                  type="text"
                  v-model="filters.id_zaz"
                  label="ZAZ"
                  @input="applyFilters"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  hide-details
                  type="text"
                  v-model="filters.loading_place"
                  label="ZAŁADUNEK"
                  @input="applyFilters"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  hide-details
                  type="text"
                  v-model="filters.unloading_place"
                  label="ROZŁADUNEK"
                  @input="applyFilters"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-select
                  hide-details
                  :items="searchStatus"
                  v-model="filters.delivery_status"
                  label="STATUS"
                  @change="applyFilters"
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-select
                  hide-details
                  :items="searchDelivery"
                  v-model="filters.delivery_method"
                  label="DOSTAWA"
                  @change="applyFilters"
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-select
                  hide-details
                  :items="orderTypes"
                  v-model="filters.order_type"
                  label="TRANSPORT"
                  @change="applyFilters"
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-select
                  hide-details
                  :items="priorityItems"
                  v-model="filters.priority"
                  label="PILNOŚĆ"
                  clearable
                  @change="applyFilters"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-layout justify-end>
                  <v-btn dark @click="clearFilters" color="primary">wyczyść filtry</v-btn>
                  <v-btn dark color="blue darken-2" @click="applyFilters" style="margin-left: 10px;">ZASTOSUJ</v-btn>
                </v-layout>
              </v-col>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        show-select
        dense
        fixed-header
        height="600px"
        v-model="selected"
        :headers="headers"
        :items="filteredDesserts"
        :items-per-page="20"
        class="elevation-1 table orders-table"
        id="printable"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-checkbox
              :input-value="allFilteredSelected"
              :indeterminate="someFilteredSelected"
              @change="toggleSelectAllFiltered"
              class="mt-0"
              hide-details
              style="max-width: 40px; margin-right: 10px;"
            ></v-checkbox>
            <v-toolbar-title>Lista zamówień</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-if="canManageOrders"
                  v-bind="attrs"
                  v-on="on"
                  @click="disabled = false"
                >
                  Dodaj Zamówienie
                </v-btn>
                <v-btn
                  color="black"
                  outlined
                  class="mb-2 mr-3"
                  v-if="canPrint"
                  @click="sendData()"
                >
                  <v-icon> mdi-printer </v-icon>
                </v-btn>
              </template>
              <v-card height="100%">
                <v-card-title>
                  <span v-text="formTitle"></span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-layout wrap>
                      <v-col cols="6">
                        <v-text-field
                          :rules="[rules.required]"
                          :disabled="disabled ? true : false"
                          v-model="editedItem.id_zas"
                          label="ZAS"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          :disabled="disabled ? true : false"
                          :rules="[rules.required, rules.number]"
                          v-model="editedItem.id_zaz"
                          label="ZAZ"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          placeholder="00-000 Nazwa Miejscowości"
                          :disabled="disabled ? true : false"
                          :rules="[rules.required, rules.postalcode]"
                          v-model="editedItem.loading_place"
                          label="ZAŁADUNEK"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          :disabled="disabled ? true : false"
                          :rules="[rules.required, rules.postalcode]"
                          placeholder="00-000 Nazwa Miejscowości"
                          v-model="editedItem.unloading_place"
                          label="ROZŁADUNEK"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          :disabled="disabled ? true : false"
                          :rules="[rules.required]"
                          v-model="editedItem.weight"
                          label="WAGA"
                          type="number"
                          placeholder="00,00"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          :disabled="disabled ? true : false"
                          :rules="[rules.required]"
                          :items="transportMethods"
                          label="DOSTAWA"
                          v-model="editedItem.delivery_method"
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          :disabled="disabled ? true : false"
                          :rules="[rules.required]"
                          v-model="editedItem.drivers_settlement"
                          label="ROZLICZENIE"
                          :items="driverSettlement"
                          type="number"
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          type="number"
                          :disabled="disabled ? true : false"
                          :rules="[rules.required, rules.number]"
                          v-model="editedItem.planned_transport_cost"
                          label="STAWKA"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          v-model="editedItem.order_type"
                          :items="orderTypes"
                          label="TRANSPORT"
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          :disabled="disabled ? true : false"
                          :rules="[rules.required]"
                          v-model="editedItem.delivery_status"
                          :items="orderStatus"
                          label="STATUS"
                        ></v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          :disabled="disabled ? true : false"
                          v-model="editedItem.priority"
                          :items="priorityItems"
                          label="PILNOŚĆ"
                          clearable
                        ></v-select>
                      </v-col>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions class="mr-8 pb-12">
                  <v-spacer></v-spacer>
                  <v-btn color="red" dark @click="close"> Anuluj </v-btn>
                  <v-btn color="blue darken-1" dark @click="save">
                    Zapisz
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title
                  >Czy na pewno chcesz usunąć to zamówienie?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" dark @click="closeDelete">Nie</v-btn>
                  <v-btn color="blue darken-1" dark @click="deleteItemConfirm"
                    >Tak</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="createCommentDialog" width="500" persistent>
              <v-card class="pa-5">
                <v-card-title>Dodaj treść komentarza</v-card-title>
                <v-card-subtitle>W przypadku problemu z dodaniem komentarza (problem tymczasowy), wciśnij przycisk odśwież sesję na górze strony.</v-card-subtitle>
                <v-container>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedComment.content"
                      label="Treść komentarza"
                    ></v-text-field>
                  </v-col>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" dark @click="createCommentDialog = false">
                    anuluj
                  </v-btn>
                  <v-btn color="blue darken-1" dark @click="addComment">
                    zapisz
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="successDialog" width="500">
              <v-card class="pa-5">
                <v-layout column>
                  <span>{{ successMessage }}</span>
                  <v-layout justify-end>
                    <v-btn
                      class="mt-3"
                      dark
                      color="blue"
                      @click="successDialog = false"
                      >zamknij</v-btn
                    ></v-layout
                  >
                </v-layout>
              </v-card>
            </v-dialog>
            <!-- <v-btn @click="formatDate"></v-btn> -->
            <v-dialog v-model="errorDialog" width="500">
              <v-card class="pa-5">
                <v-layout column>
                  <span>{{ errorMessage }}</span>
                  <v-layout justify-end>
                    <v-btn
                      class="mt-3"
                      dark
                      color="blue"
                      @click="errorDialog = false"
                      >zamknij</v-btn
                    ></v-layout
                  >
                </v-layout>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.priority="{ item }">
          <v-chip
            v-if="item.priority"
            small
            dark
            :color="getPriorityColor(item.priority)"
          >
            {{ item.priority }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon v-if="canAddComments" class="mr-05" small @click="editItem(item, 5)">
            mdi-plus
          </v-icon>

          <span class="mx-1 d-inline-flex align-center justify-center rounded-circle" style="background-color: #4CAF50; color: white; width: 20px; height: 20px; font-size: 12px; font-weight: bold; cursor: pointer;" @click="disabled = false; editItem(item, 2); getComments();">
            {{ item.comment.length }}
          </span>
          
          <v-icon v-if="canManageOrders" small class="mr-1" @click="disabled = false; editItem(item); getComments();">
            mdi-pencil
          </v-icon>

          <v-icon v-if="canManageOrders" small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
      </v-data-table>
    </v-col>
    <iframe
      name="print_frame"
      width="0"
      height="0"
      frameborder="0"
      src="about:blank"
    ></iframe>
    <v-dialog max-width="800px" v-model="CommentViewDialog">
      <v-card>
        <v-layout class="py-8" column>
          <v-row align="center" justify="center">
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="amber"
            ></v-progress-circular>
          </v-row>
          <v-list style="word-wrap: break-word" three-line v-if="!loading">
            <v-row class="mx-1 mt-2 mb-1">
              <span
                style="color: black; font-size: 20px"
                class="ml-3 pb-3 font-weight-bold"
                >Komentarze</span
              >
              <v-spacer></v-spacer>
              <v-btn class="mr-2" dark color="red" small @click="closeDialog()"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-row>
            <v-divider></v-divider>
            <template v-for="(comment, index) in comments">
              <v-list-item :key="index">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ comment.author }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >{{ comment.content }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>{{
                    comment.createdAt
                  }}</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import api from "../../services/user.service.js";
var dateFormat = require("dateformat");
export default {
  data() {
    return {
      CommentViewDialog: false,
      searchStatus: [
        
        "OCZEKUJĄCE",
        "DOSTĘPNE",
        "PRZERZUT",
        "ZREALIZOWANE",
        "ODRZUCONE",
      
      ],

      searchDelivery: [
        "TIR",
        "TIR ŁĄCZONY",
        "HDS",
        "HDS ŁĄCZONY",
        "WÓZEK",
        "WÓZEK ŁĄCZONY",
        "KURIER",
        "OW",
        "PRODUCENT"
      ],
      loading_place_search: '',
      unloading_place_search: '',
      delivery_status_search: '',
      delivery_search: '',
      order_type_search: '',
      zaz_search: '',
      disabled: false,
      createCommentDialog: false,
      loading: true,
      user: {},
      mask: "#####? AAAAAAAAAAAAAAAAAAAA",
      successDialog: false,
      successMessage: "",
      errorDialog: false,
      errorMessage: "",
      dialog: false,
      dialogDelete: false,
      transportMethods: [
        "TIR",
        "TIR ŁĄCZ",
        "HDS",
        "HDS ŁĄCZ",
        "WÓZEK",
        "WÓZEK ŁĄCZ",
        "KURIER",
        "OW",
        "PROD."
      ],
      //  transportTypes: ["kurier", "HDS", "firana"], //! do usunięcia ale czekam na twoje info jak to usuniesz, póki co zakomentowałem text-fielda
      orderStatus: [
        "OCZEKUJĄCE",
        "DOSTĘPNE",
        "PRZERZUT",
        "ZREALIZOWANE",
        "ODRZUCONE",
      ],
      orderTypes: [
        "PROTEKTOR",
        "OBCY"
      ],
      driverSettlement: [
        "FV",
        "FV EUR",
        "KIEROWCA",
        "KIEROWCA EUR",
        "OW",
      ],
      priorityItems: [
        "WYSOKI",
        "ŚREDNI",
        "NISKI",
      ],
      comments: [],
      selected: [],
      selectedItems: [],
      rules: {
        number: (v) => {
          if (!v.trim()) return true;
          if (
            !isNaN(parseFloat(v)) &&
            v >= 0 &&
            v <= 99999999999999999999999999999
          )
            return true;
          return "W tym polu można wpisać tylko cyfry";
        },
        required: (value) => !!value || "To pole jest wymagane",
        postalcode: (value) => {
          const pattern = /\d+\s+([A-Z])/;
          return pattern.test(value) || "Musisz wpisać kod pocztowy!";
        },
      },
      headers: [
        {
          text: "Data dodania",
          align: "start",
          sortable: true,
          value: "createdAtFormated"
        },
        {
          text: "ZAS",
          align: "start",
          sortable: true,
          value: "id_zas",
        },
        { 
          text: "ZAZ", 
          value: "id_zaz", 
          sortable: true
        },
        {
          text: "Załadunek",
          value: "loading_place",
          sortable: true,
        },
        {
          text: "Rozładunek",
          value: "unloading_place",
          sortable: true,
        },
        { 
          text: "Waga", 
          value: "weight"
        },
        { 
          text: "Stawka", 
          value: "planned_transport_cost" 
        },
        { 
          text: "Dostawa", 
          value: "delivery_method", 
          sortable: true, 
        },
        { 
          text: "Status", 
          value: "delivery_status", 
          sortable: true
        },
        { 
          text: "Transport", 
          value: "order_type", 
          sortable: true 
        },
        { 
          text: "Rozliczenia", 
          value: "drivers_settlement", 
        },
        { text: "Pilność", value: "priority", sortable: true },
        { text: "Edycja", value: "actions", sortable: false, },
      ],
      zamowienia: [],
      allZamowienia: [],
      editedIndex: -1,
      editedItem: {
        id_zas: "",
        id_zaz: "",
        loading_place: "",
        unloading_place: "",
        order_type: "",
        weight: "",
        freight_rate: "",
        delivery_method: "",
        transport_type: "",
        drivers_settlement: "",
        planned_transport_cost: "",
        delivery_status: "",
        priority: "NISKI",
        comment: "",
      },
      editedComment: {
        content: "",
        author: "",
        orderId: "",
      },
      defaultItem: {
        id_zas: "",
        id_zaz: "",
        loading_place: "",
        unloading_place: "",
        order_type: "",
        freight_rate: "",
        weight: "",
        delivery_method: "",
        transport_type: "",
        drivers_settlement: "",
        planned_transport_cost: "",
        delivery_status: "",
        priority: "NISKI",
        comment: "",
      },
      filters: {
        id_zaz: "",
        loading_place: "",
        unloading_place: "",
        delivery_method: "",
        delivery_status: "",
        order_type: "", 
        priority: "",
      }
    };
  },
  computed: {
    canManageOrders() {
      return this.user && (this.user.roleId === 2 || this.user.roleId === 3);
    },
    canAddComments() {
      return this.user && (this.user.roleId === 2 || this.user.roleId === 3);
    },
    canPrint() {
      return this.user && this.user.roleId !== 1;
    },
    filteredDesserts() {
      
      var conditions = [];
      
      if (this.loading_place_search) {
        conditions.push(this.loadingPlaceFilter);
      }

      if (this.unloading_place_search) {
        conditions.push(this.unloadingPlaceFilter);
      }

      if (this.zaz_search) {
        console.log("Coś działa")
        conditions.push(this.zazFilter);
      }

      if (this.delivery_status_search) {
        conditions.push(this.deliveryStatusFilter);
      }

      if (this.delivery_search) {
        conditions.push(this.deliveryFilter);
      }

      if (this.order_type_search) {
        conditions.push(this.orderTypeFilter);
      }
      
      if (conditions.length > 0) {
        return this.zamowienia.filter((dessert) => {
          return conditions.every((condition) => {
            return condition(dessert);
          })
        })
      }
      
      return this.zamowienia;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Dodaj zamówienie" : "Edytuj zamówienie";
    },
    allFilteredSelected() {
      return this.filteredDesserts.length > 0 && this.filteredDesserts.every(item => this.selected.includes(item));
    },
    someFilteredSelected() {
      return this.filteredDesserts.some(item => this.selected.includes(item)) && !this.allFilteredSelected;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    // selected: function () {
    //   console.log(this.selected);
    // },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.initialize();
  },
  methods: {
      reloadFunction() {
        location.reload(true)
      
    },

    toggleSelectAllFiltered() {
      if (this.allFilteredSelected) {
        this.selected = this.selected.filter(item => !this.filteredDesserts.includes(item));
      } else {
        this.selected = [...new Set([...this.selected, ...this.filteredDesserts])];
      }
    },

    closeDialog: function () {
        this.CommentViewDialog = false
      },
    loadingPlaceFilter(item){
      return item.loading_place.toLowerCase().includes(this.loading_place_search.toLowerCase());
    },

    unloadingPlaceFilter(item){
      return item.unloading_place.toLowerCase().includes(this.unloading_place_search.toLowerCase());
    },
    
    zazFilter(item){
      return item.id_zaz.toLowerCase().includes(this.zaz_search.toLowerCase());
    },

    deliveryStatusFilter(item){
      return item.delivery_status.toLowerCase().includes(this.delivery_status_search.toLowerCase());
    },

    deliveryFilter(item){
      return item.delivery_method.toLowerCase().includes(this.delivery_search.toLowerCase());
    },

    orderTypeFilter(item){
      return item.order_type ? item.order_type.toLowerCase().includes(this.order_type_search.toLowerCase()) : false;
    },

    getPriorityColor(priority) {
      const map = { "WYSOKI": "red darken-1", "ŚREDNI": "orange darken-1", "NISKI": "green" };
      return map[priority] || "grey";
    },


    sendData() {
      if (!this.canPrint) {
        this.error("Brak uprawnień do drukowania.");
        return;
      }

      this.selected.forEach(element => {
        element.createdAt
      });
      localStorage.setItem("dataToPrint", JSON.stringify(this.selected));
      this.$router.push("print");

      // console.log("przed resetem", this.$store.state.orders)
      // this.$store.reset({ self: true, nested: false })
      //   console.log("po resecie", this.$store.state.orders)
      // this.selected.forEach((element) => {
      //   this.$store.dispatch("triggerFunction", {
      //     loading_place: element.loading_place,
      //     unloading_place: element.unloading_place,
      //     drivers_settlement: element.drivers_settlement,
      //     freight_rate: element.freight_rate,
      //     id: element.id
      //   });
      //       console.log("po dodaniu itemków", this.$store.state.orders)
      // });
    },
    print() {
      var cuttedTable = document.getElementById("printable").innerHTML;
      window.frames["print_frame"].document.body.innerHTML = cuttedTable;
      window.frames["print_frame"].window.focus();
      window.frames["print_frame"].window.print();
    },
    getComments() {
      const data = { orderId: this.editedItem.id };
      api
        .getComments(data)
        .then((response) => {
          this.comments = response.data;
          this.loading = false;
          this.comments.forEach((element) => {
            var dateToMiliseconds = Date.parse(element.createdAt);
            var dateFormated = dateFormat(
              dateToMiliseconds,
              "dd-mm-yyyy HH:MM:ss"
            );
            element.createdAt = dateFormated;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addComment() {
      if (!this.canAddComments) {
        this.error("Brak uprawnień do dodawania komentarzy.");
        return;
      }

      this.editedComment.author = this.user.username;
      this.editedComment.orderId = this.editedItem.id;

      api
        .createComment(this.editedComment)
        .then((response) => {
          this.success(response.data.message);
          this.createCommentDialog = false;
          this.editedComment.content = "";
          this.$router.go(this.$router.currentRoute);

          // this.editedComment.content.push(this.editedItem.comment);
        })
        .catch((err) => {
          this.error(err.response.data.message);
        });
    },
    // ? Funkcja działa tak, że jak input będzie 5 cyfr i nacisniesz spacje, to sam myslnik dopisze, jak ich bedzie 6 to bedzie bez myslnika, ot i cała filozofia
    changeMask() {
      // console.log(this.editedItem.unloading_place);
      // console.log(this.mask);
      if (this.editedItem.unloading_place.indexOf(" ") >= 0) {
        //? sprawdzamy, czy jest wcisnieta spacja
        if (
          this.editedItem.unloading_place.replace(/[^0-9]/g, "").length == 5
        ) {
          //? sprawdzamy, czy ilość liczb jest równa 5, jeśli tak to włączamy maskę na kod pocztowy 5 cyfrowy
          this.mask = "##-### AAAAAAAAAAAAAAAAAAAA";
        } else if (
          this.editedItem.unloading_place.replace(/[^0-9]/g, "").length == 6
        ) {
          this.mask = "###### AAAAAAAAAAAAAAAAAAAA";
        }
      }
    },
    initialize() {
      api.getAdminBoard().then(
        (response) => {
          this.zamowienia = response.data;
          
          this.zamowienia.forEach((element) => {
            const mmmm = new Date(element.createdAt)
            element.createdAtFormated = `${mmmm.getDate()}.${mmmm.getMonth() + 1}.${mmmm.getFullYear()}`;
            element.order_type_formated = element.order_type ? (element.order_type == "OBCY" ? "OBC" : "PRO") : "";
          });

          this.allZamowienia = response.data;
          this.allZamowienia.forEach((element) => {
            const mmmm = new Date(element.createdAt)
            element.createdAtFormated = `${mmmm.getDate()}.${mmmm.getMonth() + 1}.${mmmm.getFullYear()}`;
            element.order_type_formated = element.order_type ? (element.order_type == "OBCY" ? "OBC" : "PRO") : "";
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    editItem(item, dialognumber = 1) {
      this.editedIndex = this.zamowienia.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (dialognumber == 1) {
        this.dialog = true;
      } else if (dialognumber == 2) {
        this.CommentViewDialog = true;
      } else {
        this.createCommentDialog = true;
      }
    },

    deleteItem(item) {
      if (!this.canManageOrders) {
        this.error("Brak uprawnień do usuwania zamówień.");
        return;
      }

      // ! Item za wcześnie przekazany, powinien być przekazywany przy modalu dialogDelete
      this.editedIndex = this.zamowienia.indexOf(item);
      this.editedItem = Object.assign({}, item);
      api
        .delete(this.editedItem)
        .then(() => {
          // this.success(response.data.message) <--
        })
        .catch((err) => {
          console.log(err);
        });
      this.dialogDelete = true; // ! tutaj powinien być przekazany obiekt, który chcemy skasować, teraz kasujemy item, zanim Użytkownik zobaczy modala, na którym decyduje TAK/NIE
    },

    deleteItemConfirm() {
      this.zamowienia.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    success(response) {
      this.successDialog = true;
      this.successMessage = response;
      this.close();
    },
    error(err) {
      this.errorDialog = true;
      this.errorMessage = err;
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    clearFilters() {
      this.filters = {
        id_zaz: "",
        loading_place: "",
        unloading_place: "",
        delivery_method: "",
        delivery_status: "",
        order_type: "",
        priority: "",
      };
      this.initialize(); // jeśli chcesz przywrócić pełną listę po czyszczeniu
    },

    applyFilters() {
      this.zamowienia = this.allZamowienia.filter((item) => {
        return (
          (!this.filters.id_zaz || item.id_zaz.toLowerCase().includes(this.filters.id_zaz.toLowerCase())) &&
          (!this.filters.loading_place || item.loading_place.toLowerCase().includes(this.filters.loading_place.toLowerCase())) &&
          (!this.filters.unloading_place || item.unloading_place.toLowerCase().includes(this.filters.unloading_place.toLowerCase())) &&
          (!this.filters.delivery_status || item.delivery_status.toLowerCase().includes(this.filters.delivery_status.toLowerCase())) &&
          (!this.filters.delivery_method || item.delivery_method.toLowerCase().includes(this.filters.delivery_method.toLowerCase())) &&
          (!this.filters.order_type || (item.order_type && item.order_type.includes(this.filters.order_type))) &&
          (!this.filters.priority || (item.priority && item.priority.includes(this.filters.priority)))
        );
      });
    },

    save() {
      if (!this.canManageOrders) {
        this.error("Brak uprawnień do edycji zamówień.");
        return;
      }

      if (this.editedIndex > -1) {
        Object.assign(this.zamowienia[this.editedIndex], this.editedItem);
        api
          .update(this.editedItem)
          .then((response) => {
            this.success(response.data.message);
          })
          .catch((err) => {
            console.log(err.response);
            this.error(err.response.data.message);
          });
      } else {
        api
          .create(this.editedItem)
          .then((response) => {
            this.zamowienia.push(this.editedItem);
            this.success(response.data.message);
          })
          .catch((err) => {
            console.log(err);
            this.error(err.response.data.message);
          });
      }
      //   this.close();
    },
  },
};
</script>

<style>
.orders-table .v-data-table__wrapper table thead th {
  font-size: 13px !important;
  font-weight: 600 !important;
  padding: 0 8px !important;
}

.orders-table .v-data-table__wrapper table tbody td {
  font-size: 12px !important;
  line-height: 1.2 !important;
  padding: 8px 9px !important;
}

.orders-table .v-data-table__wrapper table tbody td .v-chip {
  font-size: 11px !important;
}

.orders-table .v-toolbar__content {
  padding: 10px !important;
}

.orders-table .v-data-footer {
  font-size: 13px !important;
}

.orders-table .v-data-footer__select .v-label,
.orders-table .v-data-footer__select .v-select__selection,
.orders-table .v-data-footer__pagination,
.orders-table .v-data-footer__icons-before,
.orders-table .v-data-footer__icons-after {
  font-size: 13px !important;
}

@media (min-width: 1700px) {
  .orders-table .v-data-table__wrapper table thead th {
    font-size: 15px !important;
  }

  .orders-table .v-data-table__wrapper table tbody td {
    font-size: 15px !important;
  }

  .orders-table .v-data-table__wrapper table tbody td .v-chip {
    font-size: 15px !important;
  }

  .orders-table .v-toolbar-title {
    font-size: 22px !important;
  }

  .orders-table .v-data-footer,
  .orders-table .v-data-footer__select .v-label,
  .orders-table .v-data-footer__select .v-select__selection,
  .orders-table .v-data-footer__pagination,
  .orders-table .v-data-footer__icons-before,
  .orders-table .v-data-footer__icons-after {
    font-size: 14px !important;
  }
}
</style>


